function AnimationButton() {
    return (
        <div>
        </div>
    )
}

export default AnimationButton;
